<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingTabelas"
        @add="$router.push({ path: '/tabelaLimiteMortalidade' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador ou Nome" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingTabelas"
                    :must-sort="true" :items="tabelas" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'

export default {
    components: {
        AppMainSearchCard,
    },
    computed: {
        tiposUnidadesExploracao () {
            return this.$store.state.tiposUnidadesExploracao
        },
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idTabelaMetaMortalidade', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Tabelas de Limite de Mortalidade',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idTabelaMetaMortalidade' },
            { text: 'Nome Tabela', value: 'nmTabela' },
            { text: 'Tipo Unidade de Exploração', value: 'dsTipoUep' },
        ],
        tabelas: [],
        isLoadingTabelas: false,
        isErrorTabela: false,
        query: {},
        search: '',
    }),
    methods: {
        initViewFromRoute(route) {
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'tabelaLimiteMortalidade', params: { id : value.idTabelaMetaMortalidade } })
        },
        searchItem() {
            var context = this
            var search = Object.assign({}, this.query)

            this.isLoadingTabelas = true

            this.$axios.get('tabela-meta-mortalidade/', { params: search })
            .then((response) => {
                if (response.data[0].data != null)
                {
                    let data = response.data[0].data.map(entry => {
                        let dsTipoUep = context.tiposUnidadesExploracao.find(i => i.csTipoUnidadeExploracao === entry.sgTipoUep).dsTipoUnidadeExploracao
                        return {...entry, dsTipoUep}
                    })
                    this.tabelas = data
                }
            })
            .catch((error) => {
                this.isErrorTabela = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingTabelas = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'tabelaLimiteMortalidadeSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
